<div class="processing-order-container">
  <div>
    <frodo-title [text]="title"></frodo-title>
  </div>

  <div>
    <div>
      <div class="text">
        <frodo-spinner [colorSpinner]="colorSpinner" [src]="src"> </frodo-spinner>
      </div>
    </div>
  </div>

  <div><frodo-logo [src]="logo" [alt]="logoAlt"></frodo-logo></div>
</div>
